import { gql } from '@apollo/client';

export const LOG_WATCH_PROGRESS = gql`
  mutation CourseLogWatchProgress(
    $courseId: ID!
    $position: Float!
    $duration: Float!
    $percent: Float!
  ) {
    courseLogWatchProgress(
      courseId: $courseId
      position: $position
      duration: $duration
      percent: $percent
    ) {
      id
      position
      duration
      percent
      completed
    }
  }
`;

export const LOG_WATCH_EVENT = gql`
  mutation CourseLogWatchEvent(
    $courseId: ID!
    $type: WatchEventType!
    $position: Float!
    $metadata: JSON
  ) {
    courseLogWatchEvent(
      courseId: $courseId
      type: $type
      position: $position
      metadata: $metadata
    ) {
      id
      type
      position
    }
  }
`;

export const MARK_VIDEO_ENDED = gql`
  mutation CourseMarkVideoEnded(
    $courseId: ID!
    $position: Float!
    $duration: Float!
  ) {
    courseMarkVideoEnded(
      courseId: $courseId
      position: $position
      duration: $duration
    ) {
      id
      position
      duration
      percent
      completed
    }
  }
`;

export const SUBMIT_COURSE_TEST = gql`
  mutation CourseSubmitTest(
    $courseId: ID!
    $answers: [CourseTestAnswerInput!]!
  ) {
    courseSubmitTest(courseId: $courseId, answers: $answers) {
      passed
      scorePercent
      correctCount
      totalCount
      courseCompleted
      attempt {
        id
        score
        totalPoints
        passed
        attemptedAt
      }
    }
  }
`;
